import { useMemo } from 'react';

import type { VirtualizedRow } from '../model';

export const useReversedRows = (rows: VirtualizedRow[]) => useMemo(() => [...rows].reverse(), [rows]);
